import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * StoplightChip Component
 * Display stoplight classification with color + icon
 */

interface StoplightChipProps {
  classification: "GREEN" | "YELLOW" | "RED";
  size?: "small" | "medium";
  withIcon?: boolean;
  onClick?: () => void;
}

export const StoplightChip: React.FC<StoplightChipProps> = ({
  classification,
  size = "small",
  withIcon = true,
  onClick
}) => {
  const config = {
    GREEN: {
      label: 'Green',
      color: 'success' as const,
      icon: <CheckCircleIcon />
    },
    YELLOW: {
      label: 'Yellow',
      color: 'warning' as const,
      icon: <WarningIcon />
    },
    RED: {
      label: 'Red',
      color: 'error' as const,
      icon: <CancelIcon />
    }
  };

  const { label, color, icon } = config[classification];

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      icon={withIcon ? icon : undefined}
      onClick={onClick}
      clickable={!!onClick}
    />
  );
};
